import React from "react";
import war from "./war2.jpg";
import whatsapp from "./gbBG.jpg"
import "../components.css";
import { motion } from "framer-motion";
// import { Link } from "react-router-dom";

export default function Blogs(props) {
  return (
    <div className="container">
      <div className="startup  mx-auto my-5  w-75">
        <h1 className="text-center fw-bold ">My Writings</h1>
        <p className="text-muted">
          I love to write. And I'm happy to write about various topics whether
          it's a technical deep dive or a soft skills piece Here are some of my
          articles according to my likings
        </p>
      </div>

      {/* <motion.h1
      initial={{ y: "10vh", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 1.2,
        type: "spring",
       
      }}
      className="text-center my-5 mt-5 text-primary">
        No blogs are written till now, Just busy at Matriculation ;)
      </motion.h1> */}
      <div className="blogs  ">

     


      <motion.div 
  
      initial={{ y: "100vw", opacity: -1 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.7, type: "spring",  }}
      className={`card mb-3 bg-primary  text-${props.mode==="dark"?'dark':'white'} `} style={{maxWidth: "100%"}}>
  <div className="row g-0">
    <div style={{
      backgroundImage:`url(${war})`,
      backgroundSize:'cover',
      backgroundPosition:'center',
      border:'none'


    }} className="col-md-5 col-lg-6 col-11">
     {/* <img className=" img-fluid" src={war} alt="" /> */}
    </div>
    <div className="col-md-7 col-lg-6 col-11">
      <div className={`card-body  `}>
        <h2 className="card-title">Indo-Pak War of 1965</h2>
        <p className="card-text">The Indo-Pakistani War of 1965 or the Second Kashmir Wa was a culmination of skirmishes that took place between April 1965 and September 1965 between Pakistan and India</p>
        <a style={{textDecoration:'none'}} target = "_" href="https://hamjaster.github.io/war-1965/"><button  className={`${props.mode==='dark'?"animated-btn3":"animated-btn4"}`}>  View </button></a>
        {/* <p className="card-text"><small className="text-muted"></small></p> */}
      </div>
    </div>
  </div>
      </motion.div>

      <motion.div
      initial={{ y: "100vw", opacity: -1 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.7, type: "spring",  }}
      className={`card mb-3 bg-primary  text-${props.mode==="dark"?'dark':'white'} ` }style={{maxWidth: "100%"}}>
  <div className="row g-0">
    <div style={{
      backgroundImage:`url(${whatsapp})`,
      backgroundSize:'cover',
      backgroundPosition:'center'


    }} className="col-md-5 col-lg-6 col-11">
     {/* <img className=" img-fluid" src={war} alt="" /> */}
    </div>
    <div className="col-md-7 col-lg-6 col-11">
      <div className={`card-body  `}>
        <h2 className="card-title">The Alternative version of Whatsapp you should use.</h2>
        <p className="card-text">GBWhatsApp is among the best WhatsApp mods that you could get for your device. Users know this WhatsApp mod as a multiple-account-friendly mod and so much more</p>
        <a style={{textDecoration:'none'}} target = "_" href="https://hamjaster.github.io/GbWhatsapp/"><button  className={`${props.mode==='dark'?"animated-btn3":"animated-btn4"}`}>  View </button></a>
        {/* <p className="card-text"><small className="text-muted"></small></p> */}
      </div>
    </div>
  </div>
      </motion.div>

      </div>


    </div>
  );
}
